"use client";

import { Box, Divider, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { SidebarLinks } from "@/components";
import { useSidebarCollapse } from "./SidebarWrapper";
import { useTenantData } from "@/hooks";
import { getTenantDisplayName } from "@/lib/utils/tenant";
import { TenantLogo } from "@/components/shared/TenantLogo";

export const SidebarContent = () => {
  const { isCollapsed } = useSidebarCollapse();
  const sidebarBg = useColorModeValue("white", "navy.800");
  const { tenantData } = useTenantData();
  
  // Get dynamic tenant data
  const tenantName = getTenantDisplayName(tenantData);

  return (
    <Flex w="100%" direction="column" h="100%">
      <Box
        pb="0"
        flexShrink={0}
        bg={sidebarBg}
        transition="padding 0.2s linear"
        p={isCollapsed ? "20px 10px" : "20px"}
      >
        <Flex
          alignItems="center"
          position="relative"
          transition="all 0.2s linear"
          gap={isCollapsed ? "0" : "10px"}
          px={isCollapsed ? "10px" : "20px"}
          justifyContent={isCollapsed ? "center" : "center"}
        >
          <Box flexShrink={0} transition="all 0.2s linear">
            <TenantLogo
              width={isCollapsed ? 32 : 48}
              height={isCollapsed ? 28 : 43}
              tenantData={tenantData}
              alt={tenantName}
              priority
              style={{
                transition: "all 0.2s linear",
              }}
            />
          </Box>
          <Box
            minW="0"
            overflow="hidden"
            whiteSpace="nowrap"
            opacity={isCollapsed ? 0 : 1}
            transition="all 0.2s linear"
            w={isCollapsed ? "0" : "auto"}
            maxW={isCollapsed ? "0" : "200px"}
          >
            <Text fontSize="md" fontWeight="500">
              {tenantName}
            </Text>
          </Box>
        </Flex>
        <Divider mt="20px" />
      </Box>

      <Box
        flex="1"
        pb="80px"
        bg={sidebarBg}
        overflowY="auto"
        overflowX="hidden"
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        transition="padding 0.2s linear"
        px={isCollapsed ? "10px" : "20px"}
      >
        <SidebarLinks />
      </Box>
    </Flex>
  );
};
